import { RiskConfigLofCategory } from './riskConfigLofCategory.types';
import { RiskConfigGrades } from '@Types/riskConfigGrades.types';
import { RiskConfigCofCategory } from '@Types/RiskConfigCofCategory';
import { InspectionStandardType } from './InspectionStandardType';
import { RiskMatrixObj } from './risk.types';
import { RiskPostProcessing } from '@innovyze/lib_am_common';

export enum ConfigPublishState {
	published = 'published',
	unpublished = 'unpublished',
}

export interface RiskConfig {
	configId: string;
	name: string;
	cofWeighting: number;
	lofWeighting: number;
	assetType: string;
	riskMethod: 'added' | 'multiplied';
	grades: RiskConfigGrades;
	lastRun: string;
	lastRunCompleted?: string;
	lofCfgCategories: RiskConfigLofCategory[];
	cofCfgCategories: RiskConfigCofCategory[];
	status?: string;
	runBy?: string;
	assetCount?: number;
	publishState: ConfigPublishState;
	inspectionStandard: InspectionStandardType;
	riskType?: 'linear' | 'matrix';
	matrix?: RiskMatrixObj;
	maxOverallRiskScore?: number;
	postProcessing?: RiskPostProcessing[];
}

export interface RiskDetailsRow {
	_id: string;
	ASSET_ID: string;
	CURRENT_SERVICE: string;
	CURRENT_STRUCTURAL: string;
	CURRENT_LOF: number;
	CURRENT_COF: number;
	CURRENT_RISK: number;
	GRADE: number;
	RISK_CHANGE: string;
	WEIGHTED_SCORES?: Record<string, number>;
	CONDITION_DATA?: string;
}
